module.exports = __webpack_public_path__ + "static/media/mobileArrowBack.1b0801c9.svg";